import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ReportsTable from '../../../../components/tables/ReportsTable';

const TopUpHistory = () => {
  const navigate = useNavigate();
  
  // Sample data generator for top-up history (approved and rejected)
  const generateSampleData = (count = 100) => {
    const statuses = ['Approved', 'Rejected'];
    const userRoles = [
      'Super Distributor',
      'Master Distributor',
      'Distributor',
      'Retailer',
      'API Partner'
    ];
    const names = [
      'Rajesh Kumar', 'Priya Sharma', 'Amit Patel', 'Sneha Reddy',
      'Vikram Singh', 'Anjali Gupta', 'Rahul Verma', 'Neha Joshi',
      'Suresh Yadav', 'Kavita Mehta', 'Arun Kumar', 'Pooja Singh',
      'Deepak Sharma', 'Ritu Agarwal', 'Manoj Tiwari', 'Swati Desai',
      'Sanjay Rao', 'Meera Nair', 'Karan Khanna', 'Divya Saxena'
    ];
    const admins = ['Admin', 'Super Admin', 'Manager'];
    
    return Array.from({ length: count }, (_, i) => {
      const requestDate = new Date(
        2024,
        Math.floor(Math.random() * 12),
        Math.floor(Math.random() * 28) + 1
      );
      const actionDate = new Date(requestDate);
      actionDate.setDate(actionDate.getDate() + Math.floor(Math.random() * 5));
      const status = statuses[Math.floor(Math.random() * statuses.length)];
      
      return {
        requestId: `TUR${String(i + 1).padStart(5, '0')}`,
        requestDate: requestDate.toISOString().split('T')[0],
        actionDate: actionDate.toISOString().split('T')[0],
        userName: names[Math.floor(Math.random() * names.length)],
        userRole: userRoles[Math.floor(Math.random() * userRoles.length)],
        amount: [500, 1000, 2000, 3000, 5000, 7500, 10000, 15000, 20000, 25000, 30000, 50000, 75000, 100000][
          Math.floor(Math.random() * 14)
        ],
        status: status,
        actionBy: admins[Math.floor(Math.random() * admins.length)],
        remarks: status === 'Approved' 
          ? ['Request approved successfully', 'Approved and balance credited', 'Verified and approved', 'Payment confirmed and approved'][Math.floor(Math.random() * 4)]
          : ['Insufficient documents', 'Invalid payment details', 'Duplicate request', 'Account verification pending', 'Bank details mismatch'][Math.floor(Math.random() * 5)]
      };
    });
  };

  const [data] = useState(generateSampleData(100));

  // Column definitions
  const columns = [
    { key: 'status', label: 'Status' },
    { key: 'requestId', label: 'Request ID' },
    { key: 'requestDate', label: 'Request Date' },
    { key: 'actionDate', label: 'Action Date' },
    { key: 'userName', label: 'User Name' },
    { key: 'userRole', label: 'User Role' },
    { key: 'amount', label: 'Amount (₹)' },
    { key: 'actionBy', label: 'Action By' },
    { key: 'remarks', label: 'Remarks' }
  ];

  return (
    <Container fluid className="">
      {/* Back Button */}
      <div className="mb-3">
        <Button 
          variant="outline-secondary" 
          size="sm"
          onClick={() => navigate('/top-up-request')}
          style={{
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            width: 'fit-content'
          }}
        >
          <i className="bi bi-arrow-left"></i> Back
        </Button>
      </div>
      
      <ReportsTable
        data={data}
        reportType="TopUp_History"
        columns={columns}
        title="Top-Up Request History"
      />
    </Container>
  );
};

export default TopUpHistory;

